// extracted by mini-css-extract-plugin
export default {"services":"services_services__Dojba","container":"services_container__Fvdvk","header":"services_header__8iNH4","cards":"services_cards__EkttN"};